"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _counter = require("./counter.styles");

var _incrementalCounter = _interopRequireDefault(require("./incremental-counter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Counter = function Counter(_ref) {
  var backgroundImage = _ref.backgroundImage,
      backgroundImageMobile = _ref.backgroundImageMobile,
      endText = _ref.endText,
      endMobileText = _ref.endMobileText,
      endVal = _ref.endVal,
      mobilePlaceHolder = _ref.mobilePlaceHolder,
      startText = _ref.startText,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 1.0 : _ref$speed,
      startMobileText = _ref.startMobileText,
      startVal = _ref.startVal;
  return /*#__PURE__*/_react["default"].createElement(_counter.Wrapper, {
    backgroundImage: backgroundImage,
    backgroundImageMobile: backgroundImageMobile,
    backgroundSize: "contain",
    backgroundImagePosition: "alignBottom",
    backgroundSizeMobile: "contain",
    backgroundImagePositionMobile: "alignBottom",
    showOverlay: false,
    className: "fullWidth" // TODO: remove when global styles are removed.

  }, /*#__PURE__*/_react["default"].createElement(_counter.ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(_counter.Heading, {
    hide: startMobileText && 'mobile'
  }, startText), startMobileText ? /*#__PURE__*/_react["default"].createElement(_counter.Heading, {
    hide: 'desktop'
  }, startMobileText) : null, /*#__PURE__*/_react["default"].createElement(_incrementalCounter["default"], {
    hideOnMobile: Boolean(mobilePlaceHolder),
    startVal: startVal,
    endVal: endVal,
    speed: speed
  }), mobilePlaceHolder ? /*#__PURE__*/_react["default"].createElement(_counter.MobilePlaceholder, null, mobilePlaceHolder) : null, /*#__PURE__*/_react["default"].createElement(_counter.Subheading, {
    hide: endMobileText && 'mobile'
  }, endText), endMobileText ? /*#__PURE__*/_react["default"].createElement(_counter.Subheading, {
    hide: 'desktop'
  }, endMobileText) : null));
};

Counter.propTypes = {
  backgroundImage: _propTypes["default"].string,
  backgroundImageMobile: _propTypes["default"].string,
  endMobileText: _propTypes["default"].string,
  endText: _propTypes["default"].string,
  endVal: _propTypes["default"].number,
  mobilePlaceHolder: _propTypes["default"].string,
  speed: _propTypes["default"].number,
  startMobileText: _propTypes["default"].string,
  startText: _propTypes["default"].string,
  startVal: _propTypes["default"].number
};
var _default = Counter;
exports["default"] = _default;